/* Custom Reaven — disponibilita' incrociata taglie/colorway (scheda prodotto).

   Dati: il JSON inline [data-colorway-availability] renderizzato da
   snippets/product-colorways.liquid (taglie e varianti di tutta la famiglia).

   Comportamento:
   - le colorway che non hanno la taglia selezionata sono ingrigite
     (classe product-colorways__item--nosize), aggiornate a ogni cambio taglia;
     quelle in coming soon non si ingrigiscono e non vengono mai proposte;
   - selezionando una taglia esaurita qui ma disponibile in un'altra colorway
     compare l'etichetta "Disponibile in COLORE →" sotto le taglie: il salto
     avviene al tap sull'etichetta oppure al SECONDO tap sulla stessa taglia
     (mai al primo: cambierebbe colore sotto le dita). */
(function () {
  // "sizes" arriva come elenco [taglia, disponibile 1/0, id variante]: con piu'
  // varianti per la stessa taglia (terza opzione) vale la prima disponibile
  function sizeMap(rows) {
    var map = {};
    (rows || []).forEach(function (row) {
      var entry = map[row[0]];
      if (!entry || (entry.a !== 1 && row[1] === 1)) map[row[0]] = { a: row[1], v: row[2] };
    });
    return map;
  }

  // Una istanza PER PRODOTTO: il quick-add inietta un'altra scheda prodotto
  // nella stessa pagina, e con listener globali il codice della pagina ospite
  // dirottava le taglie del modale (fino a portare l'utente sulla colorway
  // sbagliata). Ogni istanza ascolta solo dentro il proprio <product-info>.
  function initOne(dataEl) {
    if (!dataEl || dataEl.dataset.cwInit === '1') return;
    dataEl.dataset.cwInit = '1';

    var root = dataEl.closest('product-info') || dataEl.closest('.product') || document;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var currentSizes = sizeMap(data.current && data.current.sizes);
    var siblings = (data.siblings || []).map(function (s) {
      return { handle: s.handle, url: s.url, img: s.img, label: s.label, cs: s.cs === 1, sizes: sizeMap(s.sizes) };
    });

    var sizeOption = (data.sizeOption || '').toLowerCase();
    var selectedSize = data.selected || '';
    var pendingSize = null; // taglia esaurita gia' "annunciata": il secondo tap salta
    var hintEl = null;
    var box = dataEl.closest('.product-colorways');
    var announcer = box && box.querySelector('[data-cw-annuncio]');

    function sizeEntry(map, size) {
      return map && Object.prototype.hasOwnProperty.call(map, size) ? map[size] : null;
    }

    // prima colorway (ordine canonico) con la taglia disponibile, escluse quelle in coming soon
    function siblingWithSize(size) {
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i].cs) continue;
        var entry = sizeEntry(siblings[i].sizes, size);
        if (entry && entry.a === 1) return siblings[i];
      }
      return null;
    }

    function greyThumbnails() {
      root.querySelectorAll('.product-colorways__item[data-cw-handle]').forEach(function (a) {
        var sib = siblings.find(function (s) { return s.handle === a.dataset.cwHandle; });
        if (!sib) return;
        var entry = sizeEntry(sib.sizes, selectedSize);
        a.classList.toggle('product-colorways__item--nosize', !sib.cs && !(entry && entry.a === 1));
      });
    }

    // il controllo della taglia nel variant picker Dawn: bottoni (radio con
    // name = "Opzione-posizione") oppure tendina (select name="options[Opzione]")
    function isSizeInput(input) {
      if (!input || !input.closest('variant-selects, variant-radios')) return false;
      if (root !== document && !root.contains(input)) return false;
      var name = (input.name || '').toLowerCase();
      if (input.type === 'radio') return name.indexOf(sizeOption) === 0;
      if (input.tagName === 'SELECT') return name === 'options[' + sizeOption + ']';
      return false;
    }

    function currentSizeInput(value) {
      var inputs = root.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"], variant-selects select, variant-radios select');
      for (var i = 0; i < inputs.length; i++) {
        if (isSizeInput(inputs[i]) && inputs[i].value === value) return inputs[i];
      }
      return null;
    }

    function announce(text) {
      if (announcer) announcer.textContent = text;
    }

    function removeHint() {
      pendingSize = null;
      if (hintEl && hintEl.parentNode) hintEl.parentNode.removeChild(hintEl);
      if (hintEl) announce('');
      hintEl = null;
    }

    function attachHint(input) {
      var fieldset = input.closest('fieldset') || input.closest('.product-form__input');
      if (fieldset) fieldset.appendChild(hintEl);
    }

    // Dawn ri-renderizza il variant picker dopo ogni cambio variante e
    // porterebbe via l'etichetta: se e' sparita dal DOM la riattacchiamo
    // al fieldset fresco della stessa taglia.
    function ensureHintAttached() {
      if (!pendingSize || !hintEl || hintEl.isConnected) return;
      var input = currentSizeInput(pendingSize);
      if (input) attachHint(input);
    }

    function showHint(input, size, sib) {
      removeHint();
      pendingSize = size;
      var entry = sizeEntry(sib.sizes, size);

      // chip con miniatura (design H1): [foto] "XS disponibile in Harlem" ->
      hintEl = document.createElement('a');
      hintEl.className = 'product-colorways__hint';
      hintEl.href = sib.url + '?variant=' + entry.v;

      if (sib.img) {
        var thumb = document.createElement('span');
        thumb.className = 'product-colorways__hint-thumb';
        var img = document.createElement('img');
        img.src = sib.img;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        hintEl.appendChild(thumb);
      }

      var text = document.createElement('span');
      text.className = 'product-colorways__hint-text';
      var parts = (data.hint || '__SIZE__ disponibile in __COLOR__').split('__SIZE__').join(size).split('__COLOR__');
      text.appendChild(document.createTextNode(parts[0]));
      var strong = document.createElement('strong');
      strong.textContent = String(sib.label || '');
      text.appendChild(strong);
      if (parts[1]) text.appendChild(document.createTextNode(parts[1]));
      hintEl.appendChild(text);

      var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      arrow.setAttribute('viewBox', '0 0 24 24');
      arrow.setAttribute('class', 'product-colorways__hint-arrow');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.innerHTML = '<path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2"></path>';
      hintEl.appendChild(arrow);

      attachHint(input);
      announce(text.textContent);
    }

    // Dawn sostituisce l'INTERO variant-selects a ogni cambio variante:
    // l'observer va su un antenato stabile, non sul picker stesso.
    var pickerAncestor = (root !== document && root.querySelector('.product__info-container')) || (root === document ? document.body : root);
    if ('MutationObserver' in window) {
      new MutationObserver(ensureHintAttached).observe(pickerAncestor, { childList: true, subtree: true });
    }

    root.addEventListener('change', function (event) {
      if (!isSizeInput(event.target)) return;
      selectedSize = event.target.value;
      greyThumbnails();

      var mine = sizeEntry(currentSizes, selectedSize);
      if (mine && mine.a === 1) {
        removeHint();
        return;
      }
      var sib = siblingWithSize(selectedSize);
      if (sib) {
        showHint(event.target, selectedSize, sib);
      } else {
        removeHint();
      }
    });

    // secondo tap sulla stessa taglia esaurita: si salta alla colorway proposta
    root.addEventListener('click', function (event) {
      if (!pendingSize || !hintEl) return;
      var input = null;
      if (event.target.tagName === 'INPUT') {
        input = event.target;
      } else if (event.target.tagName === 'LABEL' && event.target.htmlFor) {
        input = document.getElementById(event.target.htmlFor);
      }
      if (!input || input.type !== 'radio' || !isSizeInput(input)) return;
      if (input.value === pendingSize && input.checked) {
        event.preventDefault();
        window.location.href = hintEl.href;
      }
    });

    // stato iniziale: la taglia preselezionata potrebbe gia' essere esaurita
    // (si cerca il controllo per valore: la taglia non e' sempre la prima opzione)
    greyThumbnails();
    var initial = sizeEntry(currentSizes, selectedSize);
    if (initial && initial.a !== 1) {
      var sib0 = siblingWithSize(selectedSize);
      var checked = currentSizeInput(selectedSize);
      if (sib0 && checked) showHint(checked, selectedSize, sib0);
    }
  }

  function initAll() {
    document.querySelectorAll('script[data-colorway-availability]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Il quick-add inietta una scheda prodotto dopo il caricamento: la agganciamo
  // quando compare, guardando solo i nodi aggiunti che contengono i dati colorway.
  if ('MutationObserver' in window && !window.__reavenColorwayObserver) {
    window.__reavenColorwayObserver = true;
    new MutationObserver(function (mutazioni) {
      for (var i = 0; i < mutazioni.length; i++) {
        var nodi = mutazioni[i].addedNodes;
        for (var j = 0; j < nodi.length; j++) {
          var n = nodi[j];
          if (n.nodeType !== 1) continue;
          if (n.matches('script[data-colorway-availability]')) initOne(n);
          else if (n.querySelector('script[data-colorway-availability]')) n.querySelectorAll('script[data-colorway-availability]').forEach(initOne);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
